import { useState } from "react";
import styled from "styled-components";

// 사칭 메일 공지: 진입 팝업 대신 상단 한 줄. '오늘 하루 보지 않기'는 기존 Modal과 같은 키를 쓴다.
const KEY = "homeNotice";
const today = () => new Date().toDateString();

const NoticeBar = () => {
  const [isOpen, setIsOpen] = useState(() => localStorage.getItem(KEY) !== today());
  const [expanded, setExpanded] = useState(false);
  if (!isOpen) return null;
  return (
    <Bar role="region" aria-label="공지">
      <div className="line">
        <span className="label">NOTICE</span>
        <span className="text">당사 이메일을 사칭한 스푸핑 메일에 주의하세요. 의심 메일의 첨부파일·링크는 열지 마시기 바랍니다.</span>
        <div className="actions">
          <button onClick={() => setExpanded((x) => !x)} aria-expanded={expanded}>
            {expanded ? "접기" : "자세히"}
          </button>
          <button
            onClick={() => {
              localStorage.setItem(KEY, today());
              setIsOpen(false);
            }}
          >
            오늘 하루 보지 않기
          </button>
          <button className="close" aria-label="공지 닫기" onClick={() => setIsOpen(false)}>
            ×
          </button>
        </div>
      </div>
      {expanded && (
        <div className="detail">
          당사 거래처는 기존에 연락하시던 담당자를 통해 발송 여부를 확인해 주시고, 당사와 거래관계가 없는 경우에는 해당 메일을 삭제하시기를
          권고드립니다. 당사는 관련 상황을 지속적으로 확인하고 있으며, 피해 예방을 위해 관계기관 신고 등 필요한 조치를 진행하고 있습니다. —
          경영기획실
        </div>
      )}
    </Bar>
  );
};
export default NoticeBar;

const Bar = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.ink};
  color: rgba(255, 255, 255, 0.92);
  font-size: 0.875rem;
  & > .line,
  & > .detail {
    max-width: 90rem;
    margin: 0 auto;
    box-sizing: border-box;
    padding-left: clamp(1rem, 3vw, 2.5rem);
    padding-right: clamp(1rem, 3vw, 2.5rem);
  }
  & > .line {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 0.4rem 1rem;
    padding-top: 0.65rem;
    padding-bottom: 0.65rem;
    & > .label {
      font-weight: 700;
      font-size: 0.7rem;
      letter-spacing: 0.12em;
      padding: 0.2rem 0.55rem;
      border-radius: 999px;
      background-color: ${({ theme }) => theme.colors.accent};
      color: white;
    }
    & > .text {
      flex: 1 1 20em;
    }
    & > .actions {
      display: flex;
      align-items: center;
      gap: 1rem;
      & > button {
        font: inherit;
        cursor: pointer;
        background: none;
        border: none;
        color: ${({ theme }) => theme.colors.foreground.highlightinverted};
        padding: 0;
        &:hover {
          color: white;
          text-decoration: underline;
        }
        &.close {
          font-size: 1.35rem;
          line-height: 1;
          color: white;
          text-decoration: none;
        }
      }
    }
  }
  & > .detail {
    padding-bottom: 0.9rem;
    line-height: 1.7;
    color: rgba(255, 255, 255, 0.75);
  }
`;
